import React from 'react';
import type { ListItemIconProps } from '@mui/material';
import { ListItemIcon as MuiListItemIcon } from '@mui/material';

type Props = ListItemIconProps;

const ListItemIcon: React.FC<Props> = ({ sx, ...props }) => (
    <MuiListItemIcon sx={{ color: 'text.primary', ...sx }} {...props} />
);

export default ListItemIcon;
